import React, { Component } from "react";
import { setAndGetAttributes } from "../../FormInputFields/FormInputFunctions";
import Wrp from "../../../hoc/Wrp/Wrp";
import ReactTags from "../../ReactTags";
import { IsJsonString, isSet } from "../../../Utils/CommonFunctions";
import Icons from "../../Icons/Icons";
import PagesServices from "../../../services/PagesServices";
import http from "../../../services/http";
import { extractLookupIcon, extractConfigAttributes, renderNodeChildren } from "../../../Containers/PagesContainer/PagesContainerUtils";
import MultiLookupModal from "./MultiLookupModal";

const KeyCodes = {
  comma: 188,
  enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];

class PagesMultiLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isLoading: false,
      lookupSuggestionData: [],
      multiLookupData: [],
      config: {
        apiAction: "",
        searchField: "",
        offset: "",
        limit: "",
        resultVar: "",
        recordIdField: "",
        defaultField: "",
        resultFields: [],
      },
      pageConfig: null,
      inputVariables: [],
      outputVariables: [],
      pageConfigId: null,
      tableRecords: {
        tableHead: [],
        tableData: {
          data: [],
          status: 200
        },
        pagination: {
          page: 0,
          orderBy: '',
          perPage: 10,
          direction: 'ASC',
          totalRecords: 0,
          search: ''
        }
      },
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
  }

  componentDidMount = () => {
    const { childrenProps, value } = this.props;
    // Extract config attributes from childrenProps
    if (childrenProps) {
      const config = extractConfigAttributes(childrenProps);
      if (config) {
        this.setState({ config }, () => {
          if (isSet(config.apiAction, null) !== null) {
            this.fetchPageConfigAndVariables(config.apiAction);
          }
          // Initialize with existing value if available
          if (value) {
            this.initializeFromValue(value);
          } else {
            // Fetch initial suggestions
            this.fetchLookupSuggestions('');
          }
        });
      } else if (value) {
        this.initializeFromValue(value);
      } else {
        this.fetchLookupSuggestions('');
      }
    } else if (value) {
      this.initializeFromValue(value);
    } else {
      this.fetchLookupSuggestions('');
    }
  }

  componentDidUpdate = (prevProps) => {
    const { childrenProps, value } = this.props;
    if (prevProps.value !== value) {
      if (value) {
        this.initializeFromValue(value);
      } else {
        this.setState({ multiLookupData: [] });
      }
    }
    if (prevProps.childrenProps !== childrenProps && childrenProps) {
      const config = extractConfigAttributes(childrenProps);
      if (config) {
        const prevApiAction = this.state.config.apiAction;
        this.setState({ config }, () => {
          if (isSet(config.apiAction, null) !== null && config.apiAction !== prevApiAction) {
            this.fetchPageConfigAndVariables(config.apiAction);
          }
        });
      }
    }
  }

  // Initialize multiLookupData from value (can be array of IDs or array of objects)
  initializeFromValue = (value) => {
    if (!value) return;
    const valueArray = value;
    // console.log('valueArray-019', valueArray);
    // let valueArray = [];
    // if (Array.isArray(value)) {
    //   valueArray = value;
    // } else if (typeof value === 'string') {
    //   try {
    //     const parsed = IsJsonString(value) ? JSON.parse(value) : value;
    //     valueArray = Array.isArray(parsed) ? parsed : [parsed];
    //   } catch (e) {
    //     valueArray = value.split(',').map(v => v.trim()).filter(v => v);
    //   }
    // } else {
    //   valueArray = [value];
    // }

    // Convert to multiLookupData format
    const multiLookupData = valueArray.map((item, index) => {
      if (typeof item === 'object' && item !== null) {
        return {
          id: item.id || item.value || index,
          value: item.value || item.id || item,
          label: item.label || item.text || String(item.value || item.id || item),
          text: item.text || item.label || String(item.value || item.id || item),
        };
      } else {
        return {
          id: String(item) + '_' + index,
          value: String(item),
          label: String(item),
          text: String(item),
        };
      }
    });

    this.setState({ multiLookupData });
  }

  // Fetch page config and input/output variables once
  fetchPageConfigAndVariables = async (apiAction) => {
    try {
      const pageConfigResponse = await PagesServices.getConfigByName(apiAction);
      
      if (pageConfigResponse && pageConfigResponse.code === 200 && pageConfigResponse.data) {
        const pageConfig = pageConfigResponse.data;
        const pageConfigId = pageConfig.id;
        const variablesResponse = await PagesServices.getConfigVariablesList(pageConfigId);
        
        if (variablesResponse && variablesResponse.code === 200 && variablesResponse.data) {
          const inputVariables = variablesResponse.data.content.filter(v => v.is_request === true);
          const outputVariables = variablesResponse.data.content.filter(v => v.is_response === true);
          
          this.setState({
            pageConfig,
            pageConfigId,
            inputVariables,
            outputVariables,
          }, () => {
            this.fetchLookupSuggestions('');
          });
        }
      }
    } catch (error) {
      console.error('Error fetching page config and variables:', error);
    }
  }

  // Helper function to get nested property value
  getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    const keys = path.split('.');
    let value = obj;
    for (const key of keys) {
      if (value === null || value === undefined) {
        return undefined;
      }
      value = value[key];
    }
    return value;
  };

  // Fetch lookup suggestions
  fetchLookupSuggestions = async (searchValue) => {
    const { windowName, childrenProps } = this.props;
    let { config } = this.state;
    const { searchField, offset, limit } = config || {};

    if (!config || (!config.apiAction && childrenProps)) {
      const extractedConfig = extractConfigAttributes(childrenProps);
      if (extractedConfig) {
        config = extractedConfig;
        this.setState({ config });
      }
    }

    const hasApiAction = config && config.apiAction && config.apiAction.trim() !== "";
    
    if (!hasApiAction) {
      return;
    }

    this.setState({ isLoading: true });

    const page = 0;
    const perPage = 10;
    const search = searchValue || "";

    try {
      let { pageConfigId, inputVariables, pageConfig } = this.state;
      
      if (!pageConfigId || !inputVariables || inputVariables.length === 0 || !pageConfig) {
        await this.fetchPageConfigAndVariables(config.apiAction);
        pageConfigId = this.state.pageConfigId;
        inputVariables = this.state.inputVariables;
        pageConfig = this.state.pageConfig;
        
        if (!pageConfigId || !inputVariables || inputVariables.length === 0 || !pageConfig) {
          this.setState({ isLoading: false, lookupSuggestionData: [] });
          return;
        }
      }
      
      // Get from_page_mapping from config (similar to PagesRenderComponent pattern)
      const fromMapping = pageConfig.from_page_mapping || [];
      
      // Create inputMap similar to PagesRenderComponent
      const inputMap = Object.fromEntries(
        inputVariables.map(item => [item.id, item.api_name])
      );

      // Build payload using from_page_mapping (similar to PagesRenderComponent)
      const payload = fromMapping.map(item => {
        const apiName = isSet(item?.pages_variable_name, inputMap[item.pages_variable_id]);
        
        let selectedValue = '';
        // Handle special fields from config
        if (apiName === searchField) {
          selectedValue = decodeURIComponent(search);
        } else if (apiName === offset) {
          selectedValue = page.toString();
        } else if (apiName === limit) {
          selectedValue = perPage.toString();
        }
        
        return {
          ...item,
          selected_value: isSet(selectedValue, ''),
        };
      });
      
      const API_URL = `pageconfig/${pageConfigId}/pages-config-execute`;
      const response = await http.POST(API_URL, payload);
      
      this.setState({ isLoading: false });

      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.code === 200) {
          let updateTableData = [];
          
          const responseVariables = responseData.data?.variables || [];
          const { outputVariables, pageConfig } = this.state;
          const { resultVar, defaultField, recordIdField, resultFields } = config || {};
          
          if (responseVariables && responseVariables.length > 0 && resultVar && pageConfig) {
            const toPageMapping = pageConfig.to_page_mapping || [];
            const variableMapping = {};
            
            toPageMapping.forEach((toMap) => {
              if (toMap.field_mappings && Array.isArray(toMap.field_mappings)) {
                toMap.field_mappings.forEach((mField) => {
                  if (mField.automation_variable_id && mField.pages_variable_name) {
                    variableMapping[mField.automation_variable_id] = mField.pages_variable_name;
                  }
                });
              }
            });
            
            const responseVariableMap = {};
            responseVariables.forEach((responseVar) => {
              const pageVariableName = variableMapping[responseVar.id];
              if (pageVariableName) {
                responseVariableMap[pageVariableName] = responseVar;
              }
            });
            
            const resultVariable = responseVariableMap[resultVar];
            
            if (resultVariable) {
              try {
                const recordsData = isSet(resultVariable.value, resultVariable.selected_value);
                let resRecordsData = IsJsonString(recordsData) ? JSON.parse(recordsData) : recordsData;
                
                if (!Array.isArray(resRecordsData)) {
                  resRecordsData = resRecordsData ? [resRecordsData] : [];
                }
                
                resRecordsData.forEach((record) => {
                  let displayLabel = '';
                  if (defaultField) {
                    displayLabel = defaultField.includes('.')
                      ? this.getNestedValue(record, defaultField)
                      : record[defaultField];
                  } else if (resultFields && resultFields.length > 0) {
                    const firstField = resultFields[0];
                    displayLabel = firstField.key.includes('.')
                      ? this.getNestedValue(record, firstField.key)
                      : record[firstField.key];
                  } else if (recordIdField) {
                    displayLabel = recordIdField.includes('.')
                      ? this.getNestedValue(record, recordIdField)
                      : record[recordIdField];
                  } else {
                    const firstKey = Object.keys(record)[0];
                    displayLabel = record[firstKey] || '';
                  }
                  
                  const recordId = recordIdField && recordIdField.includes('.')
                    ? this.getNestedValue(record, recordIdField)
                    : record[recordIdField] || record.id || '';
                  
                  if (displayLabel && recordId) {
                    updateTableData.push({
                      label: String(displayLabel),
                      text: String(displayLabel),
                      value: String(recordId),
                      id: String(recordId),
                    });
                  }
                });
              } catch (error) {
                console.error('Error parsing records data:', error);
              }
            }
          }
          
          this.setState({ lookupSuggestionData: updateTableData });
        }
      }
    } catch (err) {
      console.error('MultiLookup API error:', err);
      this.setState({ isLoading: false, lookupSuggestionData: [] });
    }
  };

  // DELETE/CANCEL ADDED LOOKUP VALUES
  handleDelete = (i) => {
    if (i !== -1) {
      const updateSelectedData = this.state.multiLookupData.filter((tag, index) => index !== i);
      this.updateSuggestionLookup(updateSelectedData);
    }
  }

  // ADD WHEN SELECT FROM SUGGESTION
  handleAddition = (tag) => {
    if (tag.value === undefined) {
      return;
    }
    // Check if already exists
    const exists = this.state.multiLookupData.find(item => item.value === tag.value);
    console.log('exists', exists,this.state.multiLookupData,tag);
    if (exists) {
      return;
    }
    const updateSelectedData = [...this.state.multiLookupData, tag];
    console.log('updateSelectedData', updateSelectedData);
    this.updateSuggestionLookup(updateSelectedData, true);
  }

  updateSuggestionLookup = (multiLookupData, isAuto = false) => {
    const { changeHandler } = this.props;
    
    let selectedIds = [];
    let displayNames = [];
    console.log('multiLookupData-019', multiLookupData);
    multiLookupData.forEach((selectedLookup) => {
      selectedIds.push(selectedLookup.value);
      displayNames.push(selectedLookup.label);
    });
    
    this.setState({ multiLookupData });
    console.log('multiLookupData', multiLookupData);
    if (changeHandler) {
        changeHandler(multiLookupData);
    //   changeHandler({
    //     value: selectedIds,
    //     label: displayNames.join(', '),
    //     stateValue: multiLookupData,
    //   });
    }
  }

  // DRAG AND SORT SELECTED/ADDED LOOKUP VALUES
  handleDrag = (tag, currPos, newPos) => {
    // Drag functionality can be implemented if needed
  }

  // HANDLER CLICK
  handleTagClick = (index, actionType) => {
    // Tag click handler
  }

  // SEARCHING AND LIST VALUES FROM LIST ON KEYUP
  handleInputChange = (suggestion) => {
    this.fetchLookupSuggestions(suggestion);
  }

  openMultiLoopupModalHandler = () => {
    this.setState({ isModalOpen: true });
  }

  cancelMultiLoopupModalHandler = () => {
    this.setState({ isModalOpen: false });
  }

  setMultiLookupValuesFromList = (lookupDataArray) => {
    const { changeHandler } = this.props;
    this.setState({ 
      multiLookupData: lookupDataArray,
      isModalOpen: false 
    });
    
    if (changeHandler) {
      const selectedIds = lookupDataArray.map(item => item.value);
      const displayNames = lookupDataArray.map(item => item.label);
    //   changeHandler({
    //     value: selectedIds,
    //     label: displayNames.join(', '),
    //     stateValue: lookupDataArray,
    //   });
      changeHandler(lookupDataArray);
    }
  }

  updateTableRecords = (updateRecords) => {
    this.setState({
      tableRecords: {
        ...this.state.tableRecords,
        ...updateRecords
      }
    });
  }

  render() {
    const { value, childrenProps, required, className, attributes } = this.props;
    const { lookupSuggestionData, multiLookupData, isLoading, config, isModalOpen } = this.state;
    const windowName = this.props.windowName || (attributes && attributes.windowName) || "";

    let attr = setAndGetAttributes(this.props);
    // console.log('attrthisprops', this.props);
    // Extract custom icon from children props
    let customLookupIcon = null;
    if (childrenProps) {
      customLookupIcon = extractLookupIcon(childrenProps);
    }

    // Default icon if no custom icon
    const defaultIcon = windowName ? (
      <Icons iconType={windowName} size={16} color={"#000"} />
    ) : (
      <i className="fas fa-info"></i>
    );

    const readonlyVal = attr.readOnly || false;

    // Filter suggestions to exclude already selected items
    const filteredSuggestions = lookupSuggestionData.filter((itm) => {
      return multiLookupData.findIndex(i => i.value === itm.value) === -1;
    });

    return (
      <Wrp>
        <div className="input-group autocomplete">
          <input
            type="hidden"
            value={value || ""}
            {...attr}
            autoComplete="new-multilookup"
          />
          <ReactTags
            tags={multiLookupData}
            placeHolder={'Search..'}
            suggestions={filteredSuggestions}
            delimiters={delimiters}
            handleDelete={this.handleDelete}
            handleAddition={this.handleAddition}
            handleDrag={this.handleDrag}
            handleInputChange={this.handleInputChange}
            handleTagClick={this.handleTagClick}
            readOnly={readonlyVal}
          />
          {isLoading && (
            <i
              className="fas fa-spinner fa-spin fa-lg"
              style={{
                position: "absolute",
                top: "35%",
                right: "60px",
                transform: "translateY(-50%)",
                color: "#000",
                zIndex: '999'
              }}
            />
          )}
          {!readonlyVal && (
            <div
              className={required === true ? "input-group-append mandatory" : "input-group-append"}
              onClick={this.openMultiLoopupModalHandler}
            >
              <a className="input-group-text">
                {customLookupIcon ? (
                  <span dangerouslySetInnerHTML={{ __html: renderNodeChildren(customLookupIcon) }} />
                ) : (
                  defaultIcon
                )}
              </a>
            </div>
          )}
        </div>
        <MultiLookupModal
          isModalOpen={isModalOpen}
          windowName={windowName}
          selectedValue={value}
          childrenProps={childrenProps}
          tableRecords={this.state.tableRecords}
          cancelMultiLoopupModalHandler={this.cancelMultiLoopupModalHandler}
          setMultiLookupValuesFromList={this.setMultiLookupValuesFromList}
          updateTableRecords={this.updateTableRecords}
        />
      </Wrp>
    );
  }
}

PagesMultiLookup.defaultProps = {
  isMandatory: false,
  isEvent: false,
  className: "form-control custom-arrow",
  required: false,
};

export default PagesMultiLookup;

